/**
 * Name: Edit Customer Playlist
 * Author: @Gaurav
 * Date: 19-07-2021
 */
import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/SideBar';
import { useDispatch, useSelector } from 'react-redux';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import RoundButton from '../../components/RoundButton';
import search from '../../assets/ic_search.png';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import './EditCustomerPlaylist.scss';
import { _showAlert, formatDateToDisplay } from '../../utils';
import AlertModal from '../../components/Modal';
import { colorIsDarkSimple, royalty } from '../../generalConstant';
import { Autocomplete, Breadcrumbs, Link, TextField, Typography } from '@mui/material';
import Popup from '../../components/Popup';
import Dropdown from '../../components/Dropdown';
import EditPlaylistSecondery from '../EditPlaylistSecondery';
import { LoaderSpinner } from '../../components';
import ImportCustomerPlaylist from '../../components/ImportCustomerPlaylist/ImportCustomerPlaylist';
import SortIndicator from '../../components/SortIndicator';
import PlaylistCustomerDialog from '../../components/PlaylistManagement/PlaylistCustomerDialog';
import PlaylistCopySongsDialog from '../../components/PlaylistManagement/PlaylistCopySongsDialog';
import PlaylistActionIcon from '../../components/PlaylistManagement/PlaylistActionIcon';
import { fetcher } from '../../utils/axios';
import useRangeSelection, { updateSelectedItems } from '../../utils/useRangeSelection';
import RangeSelectionButton from '../../components/RangeSelectionButton';

const useStyles = makeStyles({
  table: {
    maxHeight: '90vh',
    borderRadius: 30,
  },
});

function EditCustomer(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [selectedPlaylistToUpload, setPlaylistToUpload] = useState([]);
  const { choose: chooseRange, toggleRangeMode, resetRange, isRangeMode } = useRangeSelection();
  const [open, setOpen] = React.useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [isRoyalties, setIsRoyalties] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  // const [isEditCustomerPlaylist, setIsEditCustomerPlaylist] = useState(false);
  const [customerSelectedPlaylist, setCustomerSelectedPlaylist] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isImportPlaylist, setIsImportPlaylist] = useState(false);
  const [copyDialogPlaylist, setCopyDialogPlaylist] = useState(null);
  const [customerDialogPlaylist, setCustomerDialogPlaylist] = useState(null);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [loadingActionId, setLoadingActionId] = useState(null);
  
  // Sorting state
  const [availableSortConfig, setAvailableSortConfig] = useState({ key: null, direction: 'desc' });
  const [selectedSortConfig, setSelectedSortConfig] = useState({ key: null, direction: 'desc' });

  /**
   * Close Modal
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * getting state from redux store
   */
  const { getAllPlaylist, getAllPlaylistStatus, deleteCustomerPlaylist, addCustomerPlaylist, getCustomerPlaylist, tagList } = useSelector(
    (state) => ({
      getAllPlaylist: state.getAllPlaylist.result,
      getAllPlaylistStatus: state.getAllPlaylist.status,
      deleteCustomerPlaylist: state.deleteCustomerPlaylist.result,
      addCustomerPlaylist: state.addCustomerPlaylist.result,
      getCustomerPlaylist: state.getCustomerPlaylist.result,
      tagList: state.tagList.result,
    })
  );
  /**
   * call the get playlist api
   * watch the local state searchInput changes to search the playlist
   */
  useEffect(() => {
    dispatch({ type: 'TAG_LIST' });
  }, []);

  useEffect(() => {
    if (!customerSelectedPlaylist) dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput, tagIds: selectedTags });
  }, [searchInput, selectedTags, customerSelectedPlaylist]);

  useEffect(() => {
    if (getAllPlaylistStatus === 'initiated' || getAllPlaylistStatus === 'uninitiated') setLoading(true);
    else setLoading(false);
  }, [getAllPlaylistStatus, customerSelectedPlaylist]);

  /**
   * check the history object
   */
  useEffect(() => {
    if (props?.history?.location?.state) {
      setSelectedCustomer(props.history.location.state);
      const customer = props.history.location.state;
      if (customer.royalty_only) setIsRoyalties(true);
    }
  }, [props.history]);

  /**
   * call added playlist get api
   */
  useEffect(() => {
    if (selectedCustomer.id && !customerSelectedPlaylist) {
      dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
    }
  }, [selectedCustomer, customerSelectedPlaylist]);

  /**
   * watch add playlist api request
   */
  useEffect(() => {
    if (addCustomerPlaylist?.status === 200) {
      dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
      _showAlert('Added Successfully', 'success');
      setPlaylistToUpload([]);
    }
    if (addCustomerPlaylist?.error) {
      _showAlert(addCustomerPlaylist?.error, 'error', 8000);
    }
  }, [addCustomerPlaylist]);

  /**
   * watch delete customer p[laylist api request
   */
  useEffect(() => {
    if (deleteCustomerPlaylist?.status === 200) {
      dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
      _showAlert('Deleted Successfully', 'success');
    }
    if (deleteCustomerPlaylist?.error) {
      _showAlert(addCustomerPlaylist?.error, 'error', 8000);
    }
  }, [deleteCustomerPlaylist]);

  const filterPlaylistsByType = (playlists, type) => {
    return Array.isArray(playlists) ? playlists.filter((item) => item.type === type) : [];
  };

  const checkPlaylist = () => {
    const allType = isRoyalties ? 3 : 4;

    const customerPlaylist = Array.isArray(getCustomerPlaylist) ? getCustomerPlaylist.map((item) => item.id) : [];
    return filterPlaylistsByType(getAllPlaylist, allType).filter((item) => !customerPlaylist.includes(item.id));
  };
  const handleEditCustomerScheduler = () => {
    props.history.push({
      pathname: '/edit-customer-scheduler',
      state: selectedCustomer,
    });
  };

  const handleAddPlaylistToCustomer = () => {
    if (selectedPlaylistToUpload.length === 0) {
      _showAlert('Please select at least one playlist', 'error', 3000);
      return;
    }
    const playlists = selectedPlaylistToUpload.map((item) => item.id);
    resetRange('available-playlists');
    dispatch({ type: 'ADD_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id, playlists } });
  };

  const handleDeleteCustomerPlaylist = (playlist) => {
    dispatch({ type: 'DELETE_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id, playlists: [playlist.id] } });
    setOpen(false);
  };

  const handleSelectSongsToUpload = (event, playlist) => {
    if (!playlist) {
      resetRange('available-playlists');
      setPlaylistToUpload(event.target.checked ? [...checkPlaylist()] : []);
    } else {
      const selection = chooseRange('available-playlists', sortData(checkPlaylist(), availableSortConfig), playlist, event.target.checked, !!event.nativeEvent?.shiftKey);
      setPlaylistToUpload((current) => updateSelectedItems(current, selection));
    }
  };

  const getCustomerName = (customer) => {
    if (customer.name) {
      return customer.name;
    } else {
      let name = '';
      name = customer.firstname || '';
      name = name + ' ' + customer.lastname || '';
      return name || 'N/A';
    }
  };

  const handleAvailableSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (availableSortConfig.key === key) {
      if (availableSortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setAvailableSortConfig({ key: newKey, direction });
  };

  const handleSelectedSort = (key) => {
    let direction = 'desc';
    let newKey = key;

    if (selectedSortConfig.key === key) {
      if (selectedSortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSelectedSortConfig({ key: newKey, direction });
  };

  const sortData = (data, sortConfig) => {
    if (!sortConfig.key || !Array.isArray(data)) return data;

    return [...data].sort((a, b) => {
      const valueA = (a[sortConfig.key] || '').toString();
      const valueB = (b[sortConfig.key] || '').toString();

      return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };

  const isAdmin = JSON.parse(sessionStorage.getItem('authData'))?.user?.userRole === 1;
  const previewSongs = previewPlaylist?.songs || [];
  const openPlaylistAction = async (playlist, action) => {
    if (loadingActionId) return;
    setLoadingActionId(playlist.id);
    try {
      const playlists = await fetcher('/playlists/');
      const completePlaylist = playlists.find((item) => item.id === playlist.id);
      if (!completePlaylist) throw new Error('Playlist not found');
      if (action === 'listen') {
        if (!completePlaylist.songs?.length) {
          _showAlert('This playlist has no songs to play', 'error');
        } else {
          setPreviewPlaylist(completePlaylist);
          setPreviewIndex(0);
        }
      } else if (action === 'copy') {
        setCopyDialogPlaylist(completePlaylist);
      }
    } catch (err) {
      _showAlert('Could not load this playlist. Please try again.', 'error');
    } finally {
      setLoadingActionId(null);
    }
  };

  const playlistActions = (playlist, assigned = false) => <div className="playlist-management-actions">
    <PlaylistActionIcon kind="listen" label={`Listen to ${playlist.name}`} onClick={() => openPlaylistAction(playlist, 'listen')} disabled={!!loadingActionId} />
    <PlaylistActionIcon kind="copy" label={`Copy songs from ${playlist.name}`} onClick={() => openPlaylistAction(playlist, 'copy')} disabled={!!loadingActionId} />
    {isAdmin && (playlist.type === 3 || playlist.type === 4) && <PlaylistActionIcon kind="customers" label={`View and assign customers for ${playlist.name}`} onClick={() => setCustomerDialogPlaylist(playlist)} />}
    <PlaylistActionIcon kind="edit" label={`Edit ${playlist.name}`} onClick={() => setCustomerSelectedPlaylist(playlist)} />
    {assigned && isAdmin && <PlaylistActionIcon kind="remove" label={`Remove ${playlist.name} from this customer`} onClick={() => {
      setOpen(true);
      setSelectedPlaylist(playlist);
    }} />}
  </div>;

  return (
    <div className="main">
      <div className="sidebar">
        <Sidebar />
      </div>
      <AlertModal open={open} onClose={handleClose} handelDelete={() => handleDeleteCustomerPlaylist(selectedPlaylist)} />
      {isLoading && <LoaderSpinner />}
      <div className="leftPortion">
        <NavBar
          data="All Customers" icon={Settings} currentRouteName="Customers" breadcrumbsPath="Edit Customer Playlists"
          showPlayer={true}
          currentSong={previewSongs[previewIndex] || null}
          hasNextSong={previewIndex < previewSongs.length - 1}
          onNextSong={() => setPreviewIndex((index) => index + 1)}
          hasPrevSong={previewIndex > 0}
          onPrevSong={() => setPreviewIndex((index) => index - 1)}
          onClosePlayer={() => setPreviewPlaylist(null)}
        />
        <div className="content">
          <div className="warp_edit_row">
            <div className="editRow">
              <div className="wrap_edit">
                <p>Edit:</p>
                <RoundButton btnText="Playlists" />
                <RoundButton className="disabled-button" btnText="Scheduler" handleClick={handleEditCustomerScheduler} />
                <div className="search_row search_playlist">
                  <input
                    className="input_field search_input"
                    placeholder="Search something here..."
                    type="text"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <img src={search} alt="search" />
                </div>
                <Autocomplete
                  style={{ width: 180, marginLeft: 10 }}
                  size="small"
                  multiple
                  limitTags={2}
                  id="tags-outlined"
                  options={tagList?.tags || []}
                  getOptionLabel={(option) => option?.name}
                  defaultValue={[]}
                  filterSelectedOptions
                  onChange={(event, newValue) => {
                    const selectedTagIds = newValue?.map((tag) => tag.id);
                    setSelectedTags(selectedTagIds);
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Tags" />}
                />
                <RoundButton btnText="Royalties" className={isRoyalties ? '' : 'not-selected'} handleClick={() => setIsRoyalties(true)} />
                <RoundButton
                  btnText="unRoyalties"
                  className={!isRoyalties ? '' : 'not-selected'}
                  handleClick={() => setIsRoyalties(false)}
                />

                {isAdmin && <RoundButton btnText="Import" handleClick={() => setIsImportPlaylist(true)} />}
              </div>
            </div>
          </div>
          <TableContainer className="tbl_wraper" component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Royalty Type</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{getCustomerName(selectedCustomer)}</TableCell>
                  <TableCell>{selectedCustomer.royalty_only ? 'Royalty' : 'Free (UnRoyalty)'}</TableCell>
                  <TableCell>{selectedCustomer.business_name || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.address || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.email}</TableCell>
                  <TableCell>{formatDateToDisplay(selectedCustomer.createdAt)}</TableCell>
                  <TableCell>
                    <span className="green_circle"></span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="wrap_tbl remove_padding">
            <TableContainer className="tbl_wraper result_tbl" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {isAdmin && <TableCell>
                      <Checkbox
                        checked={checkPlaylist().length && checkPlaylist().length === selectedPlaylistToUpload.length ? true : false}
                        onChange={(event) => handleSelectSongsToUpload(event)}
                        color="primary"
                        inputProps={{ 'aria-label': 'Select all available playlists' }}
                      />
                      <RangeSelectionButton active={isRangeMode('available-playlists')} onClick={() => toggleRangeMode('available-playlists')} />
                    </TableCell>}
                    <TableCell>Result</TableCell>
                    <TableCell 
                      onClick={() => handleAvailableSort('name')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Playlist Name<SortIndicator sortConfig={availableSortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell>Tags</TableCell>
                    {/* <TableCell>Edit</TableCell> */}
                    {isAdmin && <TableCell>
                      <RoundButton handleClick={handleAddPlaylistToCustomer} btnText="Add" />
                    </TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortData(checkPlaylist(), availableSortConfig).map((playlist, index) => (
                    <TableRow key={playlist.name}>
                      {isAdmin && <TableCell>
                        <Checkbox
                          checked={selectedPlaylistToUpload.some((item) => item.id === playlist.id)}
                          onChange={(event) => handleSelectSongsToUpload(event, playlist)}
                          color="primary"
                          inputProps={{ 'aria-label': `Select ${playlist.name || 'playlist'}` }}
                        />
                      </TableCell>}
                      <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                      <TableCell>{playlist.name}</TableCell>
                      <TableCell className="tag-cell">
                        <div className="tag-container">
                          {playlist.tags && playlist.tags.length > 0 ? (
                            playlist.tags.map((tag) => (
                              <div
                                className="tag-box"
                                key={tag.id}
                                style={{
                                  background: tag.color,
                                  color: colorIsDarkSimple(tag.color) ? 'white' : 'black',
                                }}
                              >
                                {tag.name.length > 18 ? tag.name.slice(0, 18) + '...' : tag.name}
                              </div>
                            ))
                          ) : (
                            <div>-</div>
                          )}
                        </div>
                      </TableCell>

                      <TableCell align="center">
                        {playlistActions(playlist)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer
              style={{
                width: '40%',
              }}
              className="tbl_wraper result_playlist"
              component={Paper}
            >
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Result</TableCell>
                    <TableCell 
                      onClick={() => handleSelectedSort('name')}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Playlist Selected<SortIndicator sortConfig={selectedSortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell>Tags</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(getCustomerPlaylist) &&
                    sortData(getCustomerPlaylist, selectedSortConfig).map((playlist, index) => {
                      // Find the complete playlist data from getAllPlaylist
                      // const completePlaylist = Array.isArray(getAllPlaylist) ? getAllPlaylist.find(p => p.id === playlist.id) : null;
                      const tags = playlist?.tags ? playlist?.tags : [];
                      return (
                        <TableRow key={playlist.id}>
                          <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                          <TableCell>{playlist.name || 'N/A'}</TableCell>
                          <TableCell className="tag-cell">
                            {tags?.length ? (
                              <div className="tag-container">
                                {tags.map((tag) => (
                                  <div
                                    className="tag-box"
                                    key={tag.id}
                                    style={{
                                      background: tag.color,
                                      color: colorIsDarkSimple(tag.color) ? 'white' : 'black',
                                    }}
                                  >
                                    {tag.name.length > 18 ? tag.name.slice(0, 18) + '...' : tag.name}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              '-'
                            )}
                          </TableCell>

                          <TableCell>
                            {playlistActions(playlist, true)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      {!!customerSelectedPlaylist && (
        <Popup
          open={!!customerSelectedPlaylist}
          onClose={() => setCustomerSelectedPlaylist(null)}
          dialogClassName="edit-playlist-dialog-main"
        >
          <EditPlaylistSecondery
            {...props}
            backdropClassName="edit-playlist-backdrop"
            isPageOpenedAsPopup={true}
            selectedPlaylistForPopup={customerSelectedPlaylist}
            onSavePlaylist={() => {
              setCustomerSelectedPlaylist(null);
            }}
            isPlaylistRoyalty={customerSelectedPlaylist.type === 3}
          />
        </Popup>
      )}
      <ImportCustomerPlaylist
        open={isImportPlaylist}
        onClose={() => {
          setIsImportPlaylist(false);
        }}
        currentCustomer={selectedCustomer}
      />
      <PlaylistCustomerDialog
        playlist={customerDialogPlaylist}
        open={!!customerDialogPlaylist}
        onClose={() => setCustomerDialogPlaylist(null)}
        onChange={() => dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } })}
      />
      <PlaylistCopySongsDialog
        playlist={copyDialogPlaylist}
        open={!!copyDialogPlaylist}
        onClose={() => setCopyDialogPlaylist(null)}
        onSuccess={() => dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput, tagIds: selectedTags })}
      />
    </div>
  );
}

export default EditCustomer;
